export default splitHtmlString = (str, intoWords = true) => {
  const segmenter = new Intl.Segmenter(['de'], {
    granularity: intoWords ? 'word' : 'grapheme',
  });
  const segmentedText = segmenter.segment(str);
  return (
    [...segmentedText]
      // .filter((s) => s.isWordLike)
      .map((s) =>
        s.isWordLike
          ? `<span><span>${s.segment}</span></span>`
          : `<span>${s.segment}</span>`
      )
      .join('')
  );
};
